import React from 'react'
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { genfunction } from 'helpers';

const { Merchant1, Merchant2 } = window['runConfig'];

const MultiPayments = () => {

    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const donation = useSelector(state => state.reducerShopCart.donation);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const manageMyBooking = useSelector(state => state.reducerShopCart.managemybooking);
    const enteredAmountToPay = useSelector(state => state.reducerShopCart.enteredAmountToPay);
    const reducerBooking = useSelector(state => state.reducerBooking);
    let booking = reducerBooking && reducerBooking.booking[0] ? reducerBooking.booking[0] : null;

    let merchantTotals = 0;
    let merchant1Total = 0;
    let merchant2Total = 0;


    merchantTotals = manageMyBooking ?
        genfunction.CalculateMultiMerchantTotalForMMB(events, cashless, (showTransFee ? transactionfee.transactionFee[0] : null), enteredAmountToPay, booking)
        : genfunction.CalculateMultiMerchantTotal(events, gaTickets, membershipPackages, giftcards.giftcards, donation, (showTransFee ? transactionfee.transactionFee[0] : null), cashless, donationProducts);

    merchant1Total = merchantTotals.merchant1Total;
    merchant2Total = merchantTotals.merchant2Total;

    return (
        <div>
            {merchant1Total > 0 && merchant2Total > 0 ?
                <>
                    <Typography color="textSecondary" >The total
                        {' ' + (manageMyBooking ? genfunction.ccyFormat(merchant1Total + merchant2Total) : genfunction.ccyFormat(genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gaTickets, giftcards.giftcards, orderProducts, donationProducts))) + ' '}
                        will be charged in two payments:</Typography>
                    <br />
                    <Typography color="textSecondary">{Merchant1}:  {' ' + genfunction.ccyFormat(merchant1Total) + ' '}</Typography>
                    <Typography color="textSecondary">{Merchant2}:  {' ' + genfunction.ccyFormat(merchant2Total) + ' '}</Typography>
                </> :

                merchant1Total > 0 || merchant2Total > 0 ?

                    <Typography color="textSecondary" >
                        The total
                        {' ' + (manageMyBooking ? genfunction.ccyFormat(merchant1Total + merchant2Total) : genfunction.ccyFormat(genfunction.subproducttotal(events, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gaTickets, giftcards.giftcards, orderProducts, donationProducts))) + ' '}
                        will appear on your statement as  {merchant1Total > 0 ? Merchant1 : Merchant2} </Typography>
                    : null

            }
        </div>
    )
}

export default MultiPayments
